export default __webpack_public_path__ + "static/media/FK.3613ea8b.svg";